import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable, Field } from '../../commons/DataTable';

function ClientsTable({ data, total, offset, limit, onFilter }) {
  const [t] = useTranslation('CLIENTS');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="Tipo Cliente" source="type" className="text-left" />
      <Field title="Nome" source="name" className="text-left" />
      <Field title="Cognome" source="surname" className="text-left" />
      <Field
        title="Ragione Sociale"
        source="businessName"
        className="text-left"
      />
      <Field
        title="Responsabili"
        source="profile.businessName"
        className="text-left"
      />
      <Field title="Telefono" source="phone" className="text-left" />
      <Field title="Email" source="emailReference" className="text-left" />
      <Field title="Partita IVA / CF" source="taxCode" />

      <Field title="Codice Ufficio " source="office.code" />
      <Field title="Ragione Sociale Ufficio " source="office.businessName" />
      <Field title="Referente Ufficio " source="office.contactPerson" />

      <Field title="N. POD" source="lightContracts.length" />
      <Field title="N. PDR" source="gasContracts.length" />
    </DataTable>
  );
}

export default ClientsTable;
